module.exports = __webpack_public_path__ + "img/forward-clinic.692801ca.svg";